import { IAllCollectionList } from '@modules/collections/adapter/outbound/stores/allCollection.store';
import { IAllCollectionData } from '@modules/collections/domain/models/allCollection.model';
import { IGetAllCollectionUsecase } from '@modules/collections/domain/ports/getAllCollection.usecase.port';
import { canLoadMore, offset } from '@shared/helpers/pagination.helper';
import { left, right } from '@shared/utils/either.utils';
import { shuffleArrayWithLimitOutput } from '@shared/utils/random.utils';
import { IAllCollectionRepository } from '../ports/allCollection.repository.port';
export class GetAllCollectionUsecase implements IGetAllCollectionUsecase {
  constructor(private readonly allCollectionRepository: IAllCollectionRepository) {}
  async handle(prevAllCollection: IAllCollectionData[], currentPage: number, pageSize?: number): IGetAllCollectionUsecase.getAllCollectionOutput {
    const result = await this.allCollectionRepository.getAllCollection(offset(currentPage, pageSize), pageSize);
    const value = result.value;
    if (result.isLeft()) return left(value);
    const output = this._handleCollection(currentPage, value.collections, prevAllCollection, value.total);
    return right(output);
  }
  _randomCollectionRecipe(collections: IAllCollectionData[]): IAllCollectionData[] {
    return collections.map(collection => {
      return {
        ...collection,
        recipeList: shuffleArrayWithLimitOutput(collection.recipeList, 4)
      };
    });
  }
  _mergeCollection(prevData: IAllCollectionData[], currData: IAllCollectionData[]): IAllCollectionData[] {
    return [...prevData, ...currData];
  }
  _handleCollection(currentPage: number, currAllCollection: IAllCollectionData[], prevAllCollection: IAllCollectionData[], total: number): IAllCollectionList {
    const randomRecipePrev = this._randomCollectionRecipe(prevAllCollection);
    const randomRecipeCurr = this._randomCollectionRecipe(currAllCollection);
    const collections = this._mergeCollection(randomRecipePrev, randomRecipeCurr);
    return {
      collections,
      total,
      currentPage,
      canLoadMore: canLoadMore(collections.length, total)
    };
  }
}